import React, { useState } from "react";
import FixedLogsConfigTable from "./components/FixedLogsConfigTable";
import FixedLogsConfigAddEditModal from "./components/FixedLogsConfigAddEditModal";
import { SearchBar, Button, GeneralMessage } from "../../../../common/APICommon";
import { LoadingSpinner } from "../../../../common/Loading";
import { useFixedLogsConfig } from "../../../hooks/useFixedLogsConfig";
import AddIcon from '@mui/icons-material/Add';

const FixedLogsConfigModule = ({ user, employeePersonalInformationId }) => {
  const {
    data,
    loading,
    searchData,
    createConfig,
    updateConfig,
    showMessage,
    message,
    isSuccess
  } = useFixedLogsConfig(employeePersonalInformationId);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleSave = async (form) => {
    // 1. Destructure only the fields the Backend DTO expects
    // This effectively "strips out" UI-only fields like statusDisplay or dateFromFormatted
    
    const {
      id,
      dateFrom,
      dateTo,
      vesselId,
      isActive
    } = form;

    const payload = {
      employeePersonalInformationId,
      dateFrom,
      dateTo,
      vesselId,
      isActive: isActive ?? true
    };

    if (new Date(form.dateFrom) > new Date(form.dateTo)) {
        // useGeneralMessage is available in this module
        showMessage("Date From cannot be later than Date To.", false); 
        return;
    }

    if (selectedItem) {
      const audit = {
        setupArea: "Fixed Logs Config",
        actionTaken: "update",
        field: "Vessel/Dates",
        newValue: `VesselID: ${vesselId}, From: ${dateFrom}`,
        oldValue: `VesselID: ${selectedItem.vesselId}, From: ${selectedItem.dateFrom}`,
        dateSaved: new Date(),
        savedById: user.id
      };
      // Use id from destructuring or selectedItem.id
      const res = await updateConfig(selectedItem.id, payload, audit);
      if (res.success) setIsModalOpen(false);
    } else {
      const audit = {
        setupArea: "Fixed Logs Config",
        actionTaken: "insert",
        field: "New Record",
        newValue: `VesselID: ${vesselId}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      };
      const res = await createConfig(payload, audit);
      if (res.success) setIsModalOpen(false);
    }
  };

  return (
    <div className='p-4 space-y-4'>
      <div className="flex justify-between items-center">
        <SearchBar handleFilter={searchData} />
        <Button
          icon={<AddIcon />}
          name={"Add Log Config"}
          className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
          onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
        />
      </div>

      <FixedLogsConfigTable
        data={data}
        onEdit={(item) => { setSelectedItem(item); setIsModalOpen(true); }}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <FixedLogsConfigAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
      />

      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
      <LoadingSpinner loading={loading} />
    </div>
  );
};

export default FixedLogsConfigModule;